import axios from 'axios';
import i18n from '@/i18n';

export default {
  baseURL: process.env.BASE_URL + "api/action",

  getSurveyInstanceData(surveyInstanceId, includeAnswers, includeComments, includeGuidelines, cancelToken, localizationId) {
    return axios
      .get(`survey-instance/${surveyInstanceId}`, {
        baseURL: this.baseURL,
        params: {
          "localization-id": localizationId || i18n.locale,
          "include-answers": includeAnswers,
          "include-comments": includeComments,
          "include-guidelines": includeGuidelines
        },
        cancelToken: cancelToken ? cancelToken.token : null
      });
  },

  getSurveyInstances(cancelToken, localizationId) {
    return axios
      .get(`survey-instances`, {
        baseURL: this.baseURL,
        params: {
          "localization-id": localizationId || i18n.locale,
        },
        cancelToken: cancelToken ? cancelToken.token : null
      });
  },

  getSurveyInstancesForInquiry({ onlyCanCreateSurveyRevision, onlyForComplaint, searchText, pageSize, cancelToken, localizationId } = {}) {
    return axios
      .get(`survey-instances-for-inquiry`, {
        baseURL: this.baseURL,
        params: {
          "localization-id": localizationId || i18n.locale,
          "only-can-create-survey-revision": onlyCanCreateSurveyRevision || undefined,
          "only-for-complaint": onlyForComplaint || undefined,
          "search-text": searchText || undefined,
          "page-size": pageSize || undefined,
        },
        cancelToken: cancelToken ? cancelToken.token : null
      });
  },

  getSurveyInstanceHistory(surveyInstanceId, cancelToken, localizationId) {
    return axios
      .get(`survey-instance/${surveyInstanceId}/history`, {
        baseURL: this.baseURL,
        params: {
          "localization-id": localizationId || i18n.locale,
        },
        cancelToken: cancelToken ? cancelToken.token : null
      });
  },

  /* 
   * Event Types for Check History
   */
  EventType: {
    CheckSubmitted: 'CheckSubmitted',
    CheckReportCreated: 'CheckReportCreated',
    CheckReportModified: 'CheckReportModified',
    CheckReleased: 'CheckReleased',
    CheckViewed: 'CheckViewed',
    RevisionCreated: 'RevisionCreated',
    RevisionCommentAdded: 'RevisionCommentAdded',
    RevisionStatusChanged: 'RevisionStatusChanged',
  },

  /* 
   * SurveyRevision
   */
  SurveyRevisionStatus: {
    New: 0,
    Approved: 5,
    Dismissed: 10,
    DismissedCustom1: 11,
    DismissedCustom2: 12,
    DismissedCustom3: 13,
    InProgress: 20,
    InProgressAgency: 21,
    InProgressCustom1: 22,
    Recheck: 23,
    InProgressCustom2: 24,
    Solved: 25,
    Answered: 26,
    Revised: 30,
    RevisedApprovedGoodwill: 31,
    RevisedApprovedCustom1: 32,
    RevisedApprovedCustom2: 33,
    RevisedApprovedCustom3: 34,
    RevisedApproved: 35,
    RevisedDismissed: 36,
    RevisedDismissedCustom1: 37,
    RevisedDismissedCustom2: 38,
    RevisedDismissedCustom3: 39,
    Done: 40,
    Published: 90
  },

  SurveyRevisionResultAdjustment: {
      NotAdjusted: 0,
      Adjusted: 1,
      AdjustedGoodwill: 2,
      AdjustedShopperMistake: 3,
  },

  getSurveyRevisions(filter, options, cancelToken) {
    return axios.post('survey-revisions',
      { 
        'client-ids': (filter && _.size(filter.clientIds) > 0) ? filter.clientIds.join() : null,
        'project-ids': (filter && _.size(filter.projectIds) > 0) ? filter.projectIds.join() : null,
        'survey-ids': (filter && _.size(filter.surveyIds) > 0) ? filter.surveyIds.join() : null,
        'wave-ids': (filter && _.size(filter.waveIds) > 0) ? filter.waveIds.join() : null,
        'scenario-ids': (filter && _.size(filter.scenarioIds) > 0) ? filter.scenarioIds.join() : null,
        'property-ids': (filter && _.size(filter.propertyIds) > 0) ? filter.propertyIds.join('|') : null,
        'property-ids-use-logical-and': options ? options.propertyUseLogicalAnd : null,
        'client-location-ids': (filter && _.size(filter.locationIds) > 0) ? filter.locationIds.join() : null,
        'search-text': (filter && filter.searchText) ? filter.searchText : null,
        'column-filter': (filter && _.size(filter.columnFilter) > 0) ? JSON.stringify(filter.columnFilter) : null,
        'sort-by': (filter && filter.sortBy) ? filter.sortBy : null,
        'sort-descending': (filter && filter.sortDescending) ? filter.sortDescending : null,
        'localization-id': (options && options.localizationId) ? options.localizationId : i18n.locale,
        'page-size': options ? options.pageSize : null,
        'page': options ? options.page : null,
      },
      {
        baseURL: this.baseURL,
        cancelToken: cancelToken ? cancelToken.token : null
      });
  },

  getSurveyRevisionsSummary(filter, options, cancelToken) {
    return axios.post('survey-revisions/summary',
      { 
        'client-ids': (filter && _.size(filter.clientIds) > 0) ? filter.clientIds.join() : null,
        'project-ids': (filter && _.size(filter.projectIds) > 0) ? filter.projectIds.join() : null,
        'survey-ids': (filter && _.size(filter.surveyIds) > 0) ? filter.surveyIds.join() : null,
        'wave-ids': (filter && _.size(filter.waveIds) > 0) ? filter.waveIds.join() : null,
        'scenario-ids': (filter && _.size(filter.scenarioIds) > 0) ? filter.scenarioIds.join() : null,
        'property-ids': (filter && _.size(filter.propertyIds) > 0) ? filter.propertyIds.join('|') : null,
        'property-ids-use-logical-and': options ? options.propertyUseLogicalAnd : null,
        'client-location-ids': (filter && _.size(filter.locationIds) > 0) ? filter.locationIds.join() : null,
        'search-text': (filter && filter.searchText) ? filter.searchText : null,
        'column-filter': (filter && _.size(filter.columnFilter) > 0) ? JSON.stringify(filter.columnFilter) : null,
        'localization-id': (options && options.localizationId) ? options.localizationId : i18n.locale,
      },
      {
        baseURL: this.baseURL,
        cancelToken: cancelToken ? cancelToken.token : null
      });
  },

  getSurveyRevision(surveyRevisionId, cancelToken, localizationId) {
    return axios
      .get(`survey-revision/${surveyRevisionId}`, {
        baseURL: this.baseURL,
        params: {
          "localization-id": localizationId || i18n.locale,
        },
        cancelToken: cancelToken ? cancelToken.token : null
      });
  },

  setSurveyRevision(surveyRevision) {
    return axios
      .put("survey-revision", surveyRevision,
        {
          baseURL: this.baseURL,
          headers: { 'Content-Type': 'application/json' },
          transformRequest: [
            (data) =>
              // Don't serialize internal properties
              JSON.stringify(data, (key, value) => key.startsWith('_') ? undefined : value)
          ],
        });
  },

  createOrUpdateSurveyRevisionComment(surveyRevisionId, surveyRevisionComment) {
    return axios
      .put(`survey-revision/${surveyRevisionId}/comment`, surveyRevisionComment,
        {
          baseURL: this.baseURL,
        });
  },

  setSurveyInstanceRevisionMaxDateOverride(surveyRevisionId, revisionMaxDateOverride) {
    return axios
      .put(`survey-revision/${surveyRevisionId}/revision-max-date-override`,
        { RevisionMaxDateOverride: revisionMaxDateOverride },
        {
          baseURL: this.baseURL,
        });
  },

  /* 
   * SurveyImprovement
   */
  SurveyImprovementStatus: {
    New: 0,
    Revised: 30,
  },

  getSurveyImprovements(filter, options, cancelToken) {
    return axios.post('survey-improvements',
    { 
      'client-ids': (filter && _.size(filter.clientIds) > 0) ? filter.clientIds.join() : null,
      'project-ids': (filter && _.size(filter.projectIds) > 0) ? filter.projectIds.join() : null,
      'survey-ids': (filter && _.size(filter.surveyIds) > 0) ? filter.surveyIds.join() : null,
      'wave-ids': (filter && _.size(filter.waveIds) > 0) ? filter.waveIds.join() : null,
      'scenario-ids': (filter && _.size(filter.scenarioIds) > 0) ? filter.scenarioIds.join() : null,
      'property-ids': (filter && _.size(filter.propertyIds) > 0) ? filter.propertyIds.join('|') : null,
      'property-ids-use-logical-and': options ? options.propertyUseLogicalAnd : null,
      'client-location-ids': (filter && _.size(filter.locationIds) > 0) ? filter.locationIds.join() : null,
      'search-text': (filter && filter.searchText) ? filter.searchText : null,
      'column-filter': (filter && _.size(filter.columnFilter) > 0) ? JSON.stringify(filter.columnFilter) : null,
      'sort-by': (filter && filter.sortBy) ? filter.sortBy : null,
      'sort-descending': (filter && filter.sortDescending) ? filter.sortDescending : null,
      'localization-id': (options && options.localizationId) ? options.localizationId : i18n.locale,
      'page-size': options ? options.pageSize : null,
      'page': options ? options.page : null,
    },
    {
      baseURL: this.baseURL,
      cancelToken: cancelToken ? cancelToken.token : null
    });
  },

  getSurveyImprovement(surveyImprovementId, cancelToken) {
    return axios
      .get(`survey-improvement/${surveyImprovementId}`, {
        baseURL: this.baseURL,
        cancelToken: cancelToken ? cancelToken.token : null
      });
  },

  setSurveyImprovement(surveyImprovement) {
    return axios
      .put("survey-improvement", surveyImprovement,
        {
          baseURL: this.baseURL,
          headers: { 'Content-Type': 'application/json' },
          transformRequest: [
            (data) =>
              // Don't serialize internal properties
              JSON.stringify(data, (key, value) => key.startsWith('_') ? undefined : value)
          ],
        });
  },

  createOrUpdateSurveyImprovementComment(surveyImprovementId, surveyImprovementComment) {
    return axios
      .put(`survey-improvement/${surveyImprovementId}/comment`, surveyImprovementComment,
        {
          baseURL: this.baseURL,
        });
  },

  /**
   * Uploads a file attachment for a survey revision entry with optional metadata.
   * @param {number} surveyRevisionId - The survey revision ID
   * @param {number|null} surveyRevisionEntryId - The entry ID (null for revision-level attachments)
   * @param {File} file - The File object to upload
   * @param {object} metadata - Metadata: { documentType, documentDate, scope, shortDescription }
   * @returns {Promise} Axios promise
   */
  uploadSurveyRevisionAttachment(surveyRevisionId, surveyRevisionEntryId, file, metadata) {
    const formData = new FormData();
    formData.append('file', file);

    if (metadata) {
      if (metadata.documentType) formData.append('documentType', metadata.documentType);
      if (metadata.documentDate) formData.append('documentDate', metadata.documentDate);
      if (metadata.scope) formData.append('scope', metadata.scope);
      if (metadata.shortDescription) formData.append('shortDescription', metadata.shortDescription);
    }

    let url = `survey-revision/${surveyRevisionId}/attachment`;
    if (surveyRevisionEntryId) {
      url += `?survey-revision-entry-id=${surveyRevisionEntryId}`;
    }

    return axios.post(url, formData, {
      baseURL: this.baseURL,
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  },

  /*
   * Survey Revision Question Configuration
   */
  getSurveyQuestionConfiguration(surveyId) {
    return axios.get('survey-revision-question-configuration', {
      baseURL: this.baseURL,
      params: { 'survey-id': surveyId }
    });
  },

  setSurveyQuestionConfiguration(surveyId, data) {
    return axios.put('survey-revision-question-configuration', data, {
      baseURL: this.baseURL,
      params: { 'survey-id': surveyId }
    });
  },

  getSurveyGuidelineTexts(surveyId, localizationId) {
    return axios.get('survey-guideline-texts', {
      baseURL: this.baseURL,
      params: {
        'survey-id': surveyId,
        'localization-id': localizationId
      }
    });
  },

  setSurveyGuidelineTexts(surveyId, data) {
    return axios.put('survey-guideline-texts', data, {
      baseURL: this.baseURL,
      params: { 'survey-id': surveyId }
    });
  },

  /**
   * Requests an AI analysis for a specific question and the user's current complaint inputs.
   * @param {number} surveyInstanceId - The survey instance ID
   * @param {number} surveyQuestionId - The question ID being analysed
   * @param {string[]} desiredAnswerIds - IDs of the answers the user wants to achieve
   * @param {string} remarks - The justification / remarks text entered by the user
   * @param {string} [localizationId] - Optional localization override
   * @returns {Promise} Axios promise
   */
  getAiAnalysis(surveyInstanceId, surveyQuestionId, desiredAnswerIds, justification, localizationId, cancelToken) {
    return axios.post('survey-revision/ai-analysis',
      {
        SurveyInstanceId: surveyInstanceId,
        SurveyQuestionId: surveyQuestionId,
        DesiredAnswerIds: desiredAnswerIds || [],
        Justification: justification || '',
        LocalizationId: localizationId || i18n.locale,
      },
      {
        baseURL: this.baseURL,
        cancelToken: cancelToken ? cancelToken.token : null,
      });
  },

  /*
   * SurveyRevisionDraft
   */

  saveSurveyRevisionDraft(draft) {
    return axios.put('survey-revision/draft', draft, {
      baseURL: this.baseURL,
      headers: { 'Content-Type': 'application/json' },
    });
  },

  getSurveyRevisionDrafts(externalClientId) {
    return axios.get('survey-revision/drafts', {
      baseURL: this.baseURL,
      params: externalClientId != null ? { 'external-client-id': externalClientId } : undefined,
    });
  },

  getSurveyRevisionDraft(surveyRevisionDraftId) {
    return axios.get(`survey-revision/draft/${surveyRevisionDraftId}`, {
      baseURL: this.baseURL,
    });
  },

  deleteSurveyRevisionDraft(surveyRevisionDraftId) {
    return axios.delete(`survey-revision/draft/${surveyRevisionDraftId}`, {
      baseURL: this.baseURL,
    });
  }
};
